var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmazone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.517 15.5224C15.1989 17.2715 13.2884 18.2048 11.6435 18.2048C9.33713 18.2048 7.26077 16.669 5.68992 14.1146C5.5665 13.9137 5.67709 13.64 5.82519 13.7964C7.52044 15.5722 9.61655 16.6405 11.7818 16.6405C13.242 16.6405 14.8484 16.0966 16.3255 14.9678C16.5486 14.7972 16.7352 15.2309 16.517 15.5224Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3772 14.4109C17.105 14.0565 15.5712 14.2435 14.8827 14.3264C14.6729 14.3524 14.6409 14.1671 14.8299 14.0338C16.0515 13.1608 18.0561 13.4128 18.2899 13.7054C18.5236 13.9996 18.229 16.0398 17.081 17.0136C16.9049 17.1632 16.7368 17.0835 16.8152 16.8852C17.073 16.2317 17.651 14.7669 17.3772 14.4109Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3749 10.1695C12.3749 10.7227 12.39 11.184 12.0885 11.6753C11.8452 12.0747 11.4599 12.3203 11.0292 12.3203C10.4415 12.3203 10.0991 11.9049 10.0991 11.2919C10.0991 10.0817 11.2682 9.86201 12.3749 9.86201V10.1695ZM13.9186 13.6303C13.8174 13.7142 13.671 13.7202 13.5569 13.6643C13.0488 13.2729 12.9584 13.0912 12.6785 12.7177C11.8388 13.5125 11.2445 13.7502 10.1551 13.7502C8.86758 13.7502 7.86426 13.0133 7.86426 11.5375C7.86426 10.3852 8.53816 9.6004 9.49627 9.21697C10.3273 8.87748 11.4878 8.81757 12.3749 8.72372V8.53999C12.3749 8.2025 12.4029 7.8031 12.1897 7.51154C12.0024 7.24993 11.645 7.14209 11.3307 7.14209C10.7472 7.14209 10.2262 7.41967 10.0991 7.99481C10.0733 8.12262 9.97209 8.24843 9.8343 8.25442L8.34869 8.10664C8.22382 8.08068 8.08602 7.98682 8.12047 7.80909C8.46281 6.1396 10.0884 5.63635 11.5438 5.63635C12.2888 5.63635 13.262 5.82008 13.8497 6.34329C14.5947 6.98832 14.5236 7.84903 14.5236 8.78562V10.9983C14.5236 11.6633 14.8208 11.9549 15.1007 12.3143C15.1997 12.4421 15.2212 12.5959 15.0964 12.6918C14.7842 12.9334 14.2287 13.3827 13.9229 13.6343L13.9186 13.6303",
    fill: "#080707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazone);
export default __webpack_public_path__ + "static/media/amazone.9f06366b.svg";
export { ForwardRef as ReactComponent };